import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

export const ExpandableCard = styled.div`
  background: ${fromTheme('color_background')};
  padding: ${fromTheme('spacing_medium')};
  border-radius: ${fromTheme('provider_profile_border_radius')};
  // remove the border unless a custom width is configured
  border-width: ${(props) =>
    fromTheme('provider_profile_border_width')(props) || '0px'};
  border-style: ${fromTheme('provider_profile_border_style')};
  border-color: ${fromTheme('provider_profile_color_border')};

  box-shadow: ${fromTheme('provider_profile_box_shadow')};
  -webkit-box-shadow: ${fromTheme('provider_profile_box_shadow')};
  -moz-box-shadow: ${fromTheme('provider_profile_box_shadow')};

  > button {
    margin-top: ${fromTheme('spacing_large')};

    @media print {
      display: none;
    }
  }
`;

interface ExpandableContainerProps {
  containerHeight: number;
  isExpandable?: boolean;
}

export const ExpandableContainer = styled.div<ExpandableContainerProps>`
  max-height: ${(props) =>
    props.isExpandable ? `${props.containerHeight}px` : 'none'};
  overflow: hidden;
  position: relative;

  div.provider-insurances {
    padding: 0;
    margin: 0;
    border: none;
  }

  ${(props) =>
    props.isExpandable
      ? `
      ::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 30px;
        pointer-events: none;
        background: transparent;
        transition: background 1s;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          ${fromTheme('color_background')(props)} 100%
        );
      }
      `
      : ''}
`;
